import React from "react";
import { Link } from "react-router-dom";
import "./Button.css";

type ButtonTheme = "dark" | "light";

interface ButtonBaseProps {
  buttonName: string;
  theme?: ButtonTheme;
}

type ButtonLinkProps = ButtonBaseProps & {
  to: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  type?: never;
};

type ButtonActionProps = ButtonBaseProps & {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: "button" | "submit" | "reset";
  to?: never;
};

type ButtonProps = ButtonLinkProps | ButtonActionProps;

const isLinkProps = (props: ButtonProps): props is ButtonLinkProps =>
  typeof (props as ButtonLinkProps).to === "string";

function Button(props: ButtonProps) {
  const { buttonName, theme = "dark" } = props;
  const themeColors = {
    dark: "#060D0C",
    light: "#F0EDE5",
  };

  const buttonStyle = {
    color: themeColors[theme],
    "--button-color": themeColors[theme],
  } as React.CSSProperties;

  if (isLinkProps(props)) {
    return (
      <Link
        to={props.to}
        onClick={props.onClick}
        className="custom-button"
        style={buttonStyle}
      >
        {buttonName}
      </Link>
    );
  }

  return (
    <button
      className="custom-button"
      type={props.type ?? "button"}
      onClick={props.onClick}
      style={buttonStyle}
    >
      {buttonName}
    </button>
  );
}

export default Button;
